import React, { useState } from "react";
import { templates } from "../data/templates.ts";
import SearchBox from "../components/SearchBox.tsx";
import TemplateList from "../components/TemplateList.tsx";

const TemplateListPage: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredTemplates = templates.filter((template) =>
    template.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div style={{ padding: "16px", maxWidth: "800px", margin: "0 auto" }}>
      <h1>プロンプトテンプレート一覧</h1>
      <SearchBox onSearch={setSearchTerm} />
      <button
        style={{
          marginBottom: "16px",
          padding: "8px 12px",
          backgroundColor: "#28a745",
          color: "#fff",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}
        onClick={() => alert("新しいテンプレート追加画面へ")}
      >
        + 新規追加
      </button>
      <TemplateList templates={filteredTemplates} />
    </div>
  );
};

export default TemplateListPage;
